import React from 'react'

type IconProps = {
    className?: string
}

export const TemplatesIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M9.33333 7.99999H13.3333M9.33333 10.6667H13.3333M9.33333 13.3333H13.3333M2.66667 3.33332C2.66667 3.15651 2.73691 2.98694 2.86193 2.86192C2.98695 2.73689 3.15652 2.66666 3.33333 2.66666H12.6667C12.8435 2.66666 13.013 2.73689 13.1381 2.86192C13.2631 2.98694 13.3333 3.15651 13.3333 3.33332V4.66666C13.3333 4.84347 13.2631 5.01304 13.1381 5.13806C13.013 5.26309 12.8435 5.33332 12.6667 5.33332H3.33333C3.15652 5.33332 2.98695 5.26309 2.86193 5.13806C2.73691 5.01304 2.66667 4.84347 2.66667 4.66666V3.33332ZM2.66667 8.66666C2.66667 8.48985 2.73691 8.32028 2.86193 8.19525C2.98695 8.07023 3.15652 7.99999 3.33333 7.99999H6C6.17681 7.99999 6.34638 8.07023 6.47141 8.19525C6.59643 8.32028 6.66667 8.48985 6.66667 8.66666V12.6667C6.66667 12.8435 6.59643 13.013 6.47141 13.1381C6.34638 13.2631 6.17681 13.3333 6 13.3333H3.33333C3.15652 13.3333 2.98695 13.2631 2.86193 13.1381C2.73691 13.013 2.66667 12.8435 2.66667 12.6667V8.66666Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
